import { render } from "./ExpenseReceiptCreateTopSection.vue?vue&type=template&id=dc4f5f66&scoped=true"
import script from "./ExpenseReceiptCreateTopSection.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptCreateTopSection.vue?vue&type=script&lang=js"

import "./ExpenseReceiptCreateTopSection.vue?vue&type=style&index=0&id=dc4f5f66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4f5f66"]])

export default __exports__